// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xA4z","importantInfo":"styles_importantInfo__KAwjV"};